// plugins/globalMixin.js
import { defineNuxtPlugin } from '#app';


export const globalMixin = {
    data() {
        return {
            datePickerFormat: 'YYYY-MM-DD',
        };
    },

    methods: {
        convertJsonToFormData(data) {
            const formData = new FormData();

            Object.keys(data).forEach((key) => {
                if (data[key] == null || typeof data[key] === 'undefined') {
                    data[key] = '';
                }
                formData.append(key, data[key]);
            });

            if (data.mediaToProcess && data.mediaToProcess.length) {
                data.mediaToProcess.forEach((media) => {
                    if (!media.hasOwnProperty('id')) {
                        formData.append('mediaToProcess[]', media.blob, media.title);
                    }
                });
            }

            if (data.options && data.options.length) {
                data.options.forEach((option, i) => {
                    if (option.media && option.media.length) {
                        option.media.forEach((media) => {
                            if (!media.hasOwnProperty('id')) {
                                formData.append(
                                    `optionsMediaToProcess[${i}]`,
                                    media.blob,
                                    media.title
                                );
                            }
                        });
                    }
                });
                formData.delete('options');
                formData.append('options', JSON.stringify(data.options));
            }

            if (data.columns && data.columns.length) {
                formData.delete('columns');
                formData.append('columns', JSON.stringify(data.columns));
            }

            if (data.profile_group_category) {
                formData.delete('profile_group_category');
                formData.append(
                    'profile_group_category',
                    JSON.stringify(data.profile_group_category)
                );
            }

            return formData;
        },

        convertJsonToFormDataImages({ data }) {
            const formData = new FormData();

            Object.keys(data).forEach((key) => {
                if (data[key] == null || typeof data[key] === 'undefined') {
                    data[key] = '';
                }
                formData.append(key, data[key]);
            });

            if (data.mediaToProcess && data.mediaToProcess.length) {
                data.mediaToProcess.forEach((media) => {
                    if (!media.hasOwnProperty('id')) {
                        formData.append('mediaToProcess[]', media.blob, media.title);
                    }
                });
            }

            if (data.profile_group_category) {
                formData.delete('profile_group_category');
                formData.append(
                    'profile_group_category',
                    JSON.stringify(data.profile_group_category)
                );
            }

            return formData;
        },

        displayNotifySuccess(message) {
            this.$notify({
                title: 'Success',
                text: message,
                width: '50%',
                type: 'success',
                duration: 5000,
            });
        },

        displayNotifyError(message, title = 'Error') {
            this.$notify({
                title,
                text: message,
                width: '50%',
                type: 'error',
                duration: 3000,
            });
        },

        displaySurveyValidationError() {
            this.displayNotifyError(
                this.$t('General|checkAllQuestionsBeforeProceed'),
                this.$t('General|error'),
            );
        },
    },
};

export default defineNuxtPlugin((nuxtApp) => {

    nuxtApp.vueApp.mixin(globalMixin);
    nuxtApp.provide('globalMixin', globalMixin);
});
